const patterns = [
  // Warm radial gradient
  (color: string) => `radial-gradient(circle at 30% 40%, ${color}30 0%, ${color}10 50%, ${color}05 100%)`,
  // Diagonal stripes
  (color: string) => `repeating-linear-gradient(135deg, ${color}08 0px, ${color}08 20px, ${color}15 20px, ${color}15 40px)`,
  // Dot grid
  (color: string) => `radial-gradient(circle, ${color}20 1px, transparent 1px)`,
  // Wave
  (color: string) => `linear-gradient(135deg, ${color}15 25%, ${color}08 25%, ${color}08 50%, ${color}15 50%, ${color}15 75%, ${color}08 75%)`,
  // Soft diagonal
  (color: string) => `linear-gradient(145deg, ${color}20 0%, ${color}08 40%, ${color}18 100%)`,
];

const patternSizes: Record<number, string> = {
  2: "20px 20px", // dot grid
};

const trackColors: Record<string, string> = {
  office: "#1D3461",   // navy
  kitchen: "#C4564A",  // coral
  both: "#A8C5E2",     // sky
};

interface CoverPatternProps {
  track: string;
  seed?: string;
  className?: string;
}

export function CoverPattern({ track, seed = "", className = "" }: CoverPatternProps) {
  const color = trackColors[track] || trackColors.both;
  const idx = Math.abs([...seed].reduce((acc, c) => acc + c.charCodeAt(0), 0)) % patterns.length;
  const bg = patterns[idx](color);

  return (
    <div
      className={`w-full aspect-video ${className}`}
      style={{
        background: bg,
        backgroundSize: patternSizes[idx] || "100% 100%",
      }}
    />
  );
}
